import React from 'react'
import { compose } from 'recompose'
import classnames from 'classnames'
import { Input } from 'semantic-ui-react'

const PasswordInput = (props) => {
  const { label, placeHolder, input, require, editable, style, meta: { touched, error } } = props
  const activeClass = classnames({error: (touched && error)})
  return (
    <div className='fieldRow' style={{...style}}>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className='fieldInput'>
        <Input
          {...input}
          fluid
          // disabled={editable === false}
          type='password'
          className={activeClass}
          placeholder={placeHolder}
        />
      </div>
    </div>
  )
}

export default compose()(PasswordInput)